import React, { Component } from "react";
import Select from "react-select";
import Api from "../../Services/Api";

class DDLPositionLevel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            levelData: [],
            value: null
            // roleAccess: true,
        }
    }

    componentDidMount() {
        if (this.props.jobId && this.props.companyId) {
            this.getPositionLevelDdl(this.props.jobId);
        }
    }

    clear = () => {
        this.setState({
            levelData: []
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.jobId !== this.props.jobId || prevProps.companyId !== this.props.companyId) {
            if (this.props.jobId && this.props.companyId) {
                this.getPositionLevelDdl(this.props.jobId, this.props.companyId);
            } else {
                this.clear();
            }
        }
    }

    getPositionLevelDdl(jobId, companyId) {
        let payload = {
            jobId: jobId,
            companyId: companyId
        }

        Api.create('MASTERDATA_EKSAD').postGetPositionLevelDdl(payload).then(
            (res) => {
                if (res.ok && res.data.status === 'S') {
                    let array = []
                    if (res.data.data === null) {
                        this.setState({
                            levelData: []
                        })
                    } else {
                        if (this.props.all) {
                            array.push({
                                value: "ALL",
                                label: "All Level"
                            })
                        }

                        res.data.data.map((item) => {
                            array.push({
                                value: item.levelId,
                                label: item.levelCode
                            })
                        })
                        this.setState({
                            levelData: array
                        })
                    }
                }
            })
    }

    render() {
        const { label, placeHolder, mandatory, onClickView, disabled, box, hierarchy, companyId, valueCombo, onChangeCombo, name } = this.props

        return (
            <div className="margin-bottom-20px">
                <div className="margin-5px">
                    <div className="txt-site txt-11 txt-main txt-bold">
                        <h4>{label} {mandatory && <span style={{ color: 'red' }}>*</span>}</h4>
                    </div>
                </div>
                <Select
                    style={{ backgroundColor: disabled && "#E6E6E6" }}
                    styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999, fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif" }),
                        control: base => ({
                            ...base,
                            fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif"
                        }),
                    }}
                    isDisabled={!this.state.roleAccess ? disabled && true : this.state.roleAccess}
                    options={this.state.levelData}
                    onChange={(e) => {
                        if (name) {
                            onChangeCombo({ [name]: e.value, [name + "Select"]: e });
                        } else {
                            onChangeCombo({ levelId: e.value, ["levelId" + "Select"]: e })
                        }
                    }}
                    value={valueCombo ?? null}
                    {...this.props}
                />
            </div>
        );
    }
}

export default DDLPositionLevel